<div class="on-property-container">
    <div class="on-property-header">
        <div class="header-left">
            <div class="on-property-title">{{localize(langSection.OnProperty, langText.OnPropertyView)}}</div>
            <div ngbDropdown class="location-dropdown-container">
                <button ngbDropdownToggle class="btn location-dropdown">{{currentLocation | locationListItem}}</button>
                <div ngbDropdownMenu>
                    <div class="search-input-container">
                        <input type="text" class="form-control location-search-input" [(ngModel)]="locationSearchTerm" (ngModelChange)="filterLocations()"
                            placeholder="{{localize(langSection.OnProperty, langText.SearchYourLocations)}}">
                        <button class="btn" (click)="clearSearch()"><span class="icon" [ngClass]="locationSearchTerm ? 'clear' : 'search'"></span></button>
                    </div>
                    <ul class="dropdown-list">
                        @for (loc of filteredLocationOptions; track loc) {
<li ngbDropdownItem (click)="onLocationSelect(loc)"
                            [class.active]="loc?.countryCode === currentLocation?.countryCode && loc?.slicNumber === currentLocation?.slicNumber"
                           >{{loc | locationListItem}}</li>
}
                        @if (locationSearchTerm && filteredLocationOptions.length === 0) {
<li ngbDropdownItem disabled>
                            {{localize(langSection.OnProperty, langText.NoResultsMatched)}}</li>
}
                    </ul>
                </div>
                <span class="ups-select-icon"></span>
            </div>
        </div>
        <div class="header-right">
            <div class="trailer-search-box">
                <div class="input-group-text">
                    <input class="form-control rounded-0 border-dark" [(ngModel)]="trailerSearch" (input)="searchTrailers()"
                        placeholder="{{localize(langSection.OnProperty, langText.SearchAllTrailers)}}" />
                    <button aria-label="Search Locations" class="btn border-dark rounded-0 bg-grey" type="button" (click)="clearTrailerSearch()"><span
                            class="{{iconClass}}"></span></button>
                </div>
            </div>
        </div>
    </div>
    <div class="on-property-body">
        <div class="on-property-map">
            @if (mapLoaded && currentLocation) {
<div class="map">
                <on-property-map [isLoading]="locationLoading" [assetData]="assetData" [selectedTrailer]="selectedTrailer"
                    (onTrailerPointSelect)="updateSelectedTrailer($event)"></on-property-map>
            </div>
}
        </div>
        <div class="trailer-list-container">
            <div class="trailer-list-header">
                <span class="trailer-list-header-label">{{displayedTrailerCountMessage}}</span>
                <div class="filter-sort-buttons">
                    <button aria-label="Open Filters" class="filter-button btn" [class.filter-active]="filterActive" type="button"
                        (click)="onFilterClick()"></button>
                    <button aria-label="Ascending or Descending" class="ups-icon-sort btn" type="button" (click)="onSortClick()"></button>
                </div>
                @if (showFilters) {
                <div class="filter">
                    <form class="form-bubble" [formGroup]="filterForm">
                        <div class="row">
                            <div class="col">
                                <div class="available">
                                    <strong>{{localize(langSection.OnProperty, langText.TrailerState)}}</strong>
                                    <div class="form-check">
                                        <input id="available" type="checkbox" name="available" class="form-check-input" value="available"
                                            formControlName="available">
                                        <label for="available" class="form-check-label">
                                            {{localize(langSection.OnProperty, langText.Available)}}
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input id="empty" type="checkbox" name="empty" class="form-check-input" value="empty" formControlName="empty">
                                        <label for="empty" class="form-check-label">
                                            {{localize(langSection.OnProperty, langText.Empty)}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                }
                @if (showSortOptions) {
                <div class="sort">
                    <div class="sort-options">
                        <div class="available-sort" (click)="updateSort(TrailerListSort.Available)">
                            @if (sortedBy == TrailerListSort.Available && ascending) {
                            <span class="ups-icon ups-icon-arrowup"></span>
                            }
                            @if (sortedBy == TrailerListSort.Available && !ascending) {
                            <span class="ups-icon ups-icon-arrowdown"></span>
                            }
                            {{localize(langSection.OnProperty, langText.Available)}}
                        </div>
                        <div class="empty-sort" (click)="updateSort(TrailerListSort.Empty)">
                            @if (sortedBy == TrailerListSort.Empty && ascending) {
                            <span class="ups-icon ups-icon-arrowup"></span>
                            }
                            @if (sortedBy == TrailerListSort.Empty && !ascending) {
                            <span class="ups-icon ups-icon-arrowdown"></span>
                            }
                            {{localize(langSection.OnProperty, langText.Empty)}}
                        </div>
                    </div>
                </div>
                }
            </div>
            <div #trailerSection class="section-trailers">
                <trailer-list [trailers]="filteredTrailers" [isLoading]="trailerListIsLoading" [selectedTrailer]="selectedTrailer"
                    (onTrailerSelect)="updateSelectedTrailer($event)"></trailer-list>
            </div>
            <div class="export-trailer-container">
                <button (click)="exportTrailers()">{{localize(langSection.OnProperty, langText.ExportTrailerList)}}</button>
            </div>
        </div>
    </div>
</div>